import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { GlobalCoverage } from './components/GlobalCoverage';
import { Innovation } from './components/Innovation';
import { Roadmap } from './components/Roadmap';
import { FAQ } from './components/FAQ';
import { Platforms } from './components/Platforms';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <div className="accent-line" />
        <HowItWorks />
        <Features />
        <GlobalCoverage />
        <Innovation />
        <Roadmap />
        <FAQ />
        <Platforms />
        <ContactForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
